import { getDeviceType } from '@picsart/design-system/utils/device';

/**
 * Compatibility shim for the boolean device flags removed from
 * `@picsart/design-system/utils/device` in v11. v10 exposed these as
 * module-level constants evaluated once at import; v11 replaced them with the
 * pure `getDeviceType()` function. These constants reproduce the old
 * evaluate-once semantics so call sites stayed unchanged.
 */
const deviceType = getDeviceType();

export const isMobileDevice = deviceType === 'mobile';
export const isDesktopDevice = deviceType === 'desktop';
export const isDesktopOrTabletDevice = deviceType === 'desktop' || deviceType === 'tablet';
